import React from 'react'
import i18n from 'simple-react-i18n'
import Tabs from '../../../components/Tabs'
import ModelApp from './ModelApp'
import ModelKeywordsPanel from './ModelKeywordsPanel'

const TAB_MODELS = 'MODELS'
const TAB_KEYWORDS = 'KEYWORDS'

const ModelsApp = props => (
    <Tabs
        defaultTab={TAB_MODELS}
        tabs={[
            { constant: TAB_MODELS, label: i18n.models },
            { constant: TAB_KEYWORDS, label: i18n.keywords },
        ]}
    >
        {tab => (
            <>
                {tab === TAB_MODELS && <ModelApp {...props} />}
                {tab === TAB_KEYWORDS && <ModelKeywordsPanel />}
            </>
        )}
    </Tabs>
)

export default ModelsApp
